export default __webpack_public_path__ + "static/program-circle-rental-pl-e11e1f666beda24005f89a1ce0e54eff.svg";